export default __webpack_public_path__ + "static/media/AzureDevOpsPipelines.efd80314.svg";